import Divider from "../components/divider.js";

function Referenzen() {
  return <div className="main-wrapper">
    
    

    <h1>Referenzen</h1>

    <p>Das sagen meine Teilnehmenden</p>

    <Divider/>

    <p>
      „Ich habe es sehr genossen, den Jahreskurs bei Solveig zu besuchen. Sie leitet so achtsam und liebevoll an und hält den Raum, dass es mir leicht gefallen ist, mich auf die Impulse und Anregungen einzulassen. Besonders gut erinnere ich mich an das Herbstwochenende mit dem einmaligen Erleben eines ganzen Feuerwerks an Bewegung und Ausdruck. Da habe ich "getanzt" - gefühlt wie noch nie zuvor in meinem Leben - und alles kam einfach von innen aus mir heraus. Wunderbar und bereichernd!“<br/>
      <strong><br/>Karin, 58, Dipl.-Ökotrophologin</strong>
    </p>


    

  </div>;
}
export default Referenzen;